export type PersonalInfoSelectOption = {
    value: string;
    label: string;
};

export const genderOptions: PersonalInfoSelectOption[] = [
    {
        value: "male",
        label: "Male",
    },
    {
        value: "female",
        label: "Female",
    },
    {
        value: "others",
        label: "Others",
    },
];

export const countryOptions: PersonalInfoSelectOption[] = [
    {
        value: "india",
        label: "India",
    },
    {
        value: "united-states",
        label: "United States",
    },
    {
        value: "united-arab-emirates",
        label: "United Arab Emirates",
    },
];

export const stateOptionsByCountry:
    Record<string, PersonalInfoSelectOption[]> = {
    india: [
        {
            value: "andhra-pradesh",
            label: "Andhra Pradesh",
        },
        {
            value: "telangana",
            label: "Telangana",
        },
        {
            value: "tamil-nadu",
            label: "Tamil Nadu",
        },
        {
            value: "karnataka",
            label: "Karnataka",
        },
        {
            value: "maharashtra",
            label: "Maharashtra",
        },
    ],

    "united-states": [
        {
            value: "california",
            label: "California",
        },
        {
            value: "texas",
            label: "Texas",
        },
        {
            value: "new-york",
            label: "New York",
        },
    ],

    "united-arab-emirates": [
        {
            value: "dubai",
            label: "Dubai",
        },
        {
            value: "abu-dhabi",
            label: "Abu Dhabi",
        },
        {
            value: "sharjah",
            label: "Sharjah",
        },
    ],
};

export const districtOptionsByState:
    Record<string, PersonalInfoSelectOption[]> = {
    "andhra-pradesh": [
        {
            value: "tirupati",
            label: "Tirupati",
        },
        {
            value: "chittoor",
            label: "Chittoor",
        },
        {
            value: "nellore",
            label: "SPSR Nellore",
        },
        {
            value: "visakhapatnam",
            label: "Visakhapatnam",
        },
    ],

    telangana: [
        {
            value: "hyderabad",
            label: "Hyderabad",
        },
        {
            value: "rangareddy",
            label: "Ranga Reddy",
        },
        {
            value: "medchal",
            label: "Medchal–Malkajgiri",
        },
    ],

    "tamil-nadu": [
        {
            value: "chennai",
            label: "Chennai",
        },
        {
            value: "coimbatore",
            label: "Coimbatore",
        },
    ],

    karnataka: [
        {
            value: "bengaluru-urban",
            label: "Bengaluru Urban",
        },
        {
            value: "mysuru",
            label: "Mysuru",
        },
    ],

    maharashtra: [
        {
            value: "mumbai",
            label: "Mumbai",
        },
        {
            value: "pune",
            label: "Pune",
        },
    ],

    california: [
        {
            value: "los-angeles-county",
            label: "Los Angeles County",
        },
        {
            value: "san-francisco-county",
            label: "San Francisco County",
        },
    ],

    texas: [
        {
            value: "travis-county",
            label: "Travis County",
        },
        {
            value: "harris-county",
            label: "Harris County",
        },
    ],

    "new-york": [
        {
            value: "new-york-county",
            label: "New York County",
        },
    ],

    dubai: [
        {
            value: "dubai",
            label: "Dubai",
        },
    ],

    "abu-dhabi": [
        {
            value: "abu-dhabi",
            label: "Abu Dhabi",
        },
    ],

    sharjah: [
        {
            value: "sharjah",
            label: "Sharjah",
        },
    ],
};

export const cityOptionsByDistrict:
    Record<string, PersonalInfoSelectOption[]> = {
    tirupati: [
        {
            value: "tirupati-city",
            label: "Tirupati",
        },
        {
            value: "renigunta",
            label: "Renigunta",
        },
    ],

    chittoor: [
        {
            value: "chittoor-city",
            label: "Chittoor",
        },
    ],

    nellore: [
        {
            value: "nellore-city",
            label: "Nellore",
        },
    ],

    visakhapatnam: [
        {
            value: "visakhapatnam-city",
            label: "Visakhapatnam",
        },
    ],

    hyderabad: [
        {
            value: "hyderabad-city",
            label: "Hyderabad",
        },
        {
            value: "secunderabad",
            label: "Secunderabad",
        },
    ],

    rangareddy: [
        {
            value: "shamshabad",
            label: "Shamshabad",
        },
    ],

    medchal: [
        {
            value: "kukatpally",
            label: "Kukatpally",
        },
    ],

    chennai: [
        {
            value: "chennai-city",
            label: "Chennai",
        },
    ],

    coimbatore: [
        {
            value: "coimbatore-city",
            label: "Coimbatore",
        },
    ],

    "bengaluru-urban": [
        {
            value: "bengaluru",
            label: "Bengaluru",
        },
    ],

    mysuru: [
        {
            value: "mysuru-city",
            label: "Mysuru",
        },
    ],

    mumbai: [
        {
            value: "mumbai-city",
            label: "Mumbai",
        },
    ],

    pune: [
        {
            value: "pune-city",
            label: "Pune",
        },
    ],

    "los-angeles-county": [
        {
            value: "los-angeles",
            label: "Los Angeles",
        },
    ],

    "san-francisco-county": [
        {
            value: "san-francisco",
            label: "San Francisco",
        },
    ],

    "travis-county": [
        {
            value: "austin",
            label: "Austin",
        },
    ],

    "harris-county": [
        {
            value: "houston",
            label: "Houston",
        },
    ],

    "new-york-county": [
        {
            value: "new-york-city",
            label: "New York City",
        },
    ],

    dubai: [
        {
            value: "dubai-city",
            label: "Dubai",
        },
    ],

    "abu-dhabi": [
        {
            value: "abu-dhabi-city",
            label: "Abu Dhabi",
        },
    ],

    sharjah: [
        {
            value: "sharjah-city",
            label: "Sharjah",
        },
    ],
};
